import { BUNDLE_PRODUCT_CODE } from 'Components/dialogs/PaymentDlg/payment.constants';

export const APP_CODES     = ["phantom_ga_business","phantom_ga_standard","phantom_ga_online","phantom_ga_education"];
//export const APP_CODES_CN  = ["phantom_ga_business","phantom_ga_standard"];
//export const APP_ORG_CODES = ["phantom_ga_online_org","phantom_ga_business_org","phantom_ga_standard_org","phantom_ga_education_org"];
export const APP_CODES_OR_ORG_CODES_ONLINE  = ["phantom_ga_online", "phantom_ga_online_org", "phantom_ga_online_b", "phantom_ga_online_b_org", "phantom_ga_education", "phantom_ga_education_org", "pdfeditor_plus_esign_bundle", "pdfeditor_pro_plus_win", "pdfeditor_pro_plus_mac",...BUNDLE_PRODUCT_CODE];

export const APP_CODE_MAP = {
  phantom_ga_online       : { key: 'subscription.plan.online.name' },
  phantom_ga_online_org   : { key: 'subscription.plan.online.org' },
  phantom_ga_online_b     : { key: 'subscription.plan.online.name' },
  phantom_ga_online_b_org : { key: 'subscription.plan.online.org' },
  phantom_ga_business     : { key: 'subscription.plan.business.name' },
  phantom_ga_business_org : { key: 'subscription.plan.business.org' },
  phantom_ga_standard     : { key: 'subscription.plan.standard.name' },
  phantom_ga_standard_org : { key: 'subscription.plan.standard.org' },
  phantom_ga_education    : { key: 'subscription.plan.education.name' },
  phantom_ga_education_org: { key: 'subscription.plan.education.org' },
};

export const USER_TEMP_TRIAL = 'user-temp-trial';

//&identify=FPMS //FPMS表示PhantomPDF STD，FPMB: PhantomPDF BIZ，PMM: PhantomPDF MAC，FPMOL: PhantomPDF Online
export const APP_IDENTIFIES = {
  phantom_ga_online: 'FPMOL',
  phantom_ga_standard: 'FPMS',
  phantom_ga_business: 'FPMB',
  foxit_pdf_editor_ps_pro_individuals: 'FPEPPI',
  foxit_pdf_editor_ps_pro_business: 'FPEPPT'
}
/**
 * 
  订阅弹框：
    三个订阅按钮：app-detail
  account页面的订阅分组
    订阅按钮：app-list
  account页面的管理分组：
    订阅 app-detail 付款方式 my-cards 账单 my-invoices
  注销账户
    查看订阅 my-order（"notCancellation":"您当前订阅服务未到期无法注销账号。",） 
  
            let map = {
            'my-order': appStoreUrl + `/appstore/purchased`, // 
            'ticket-redirect':appStoreUrl + `/appstore/ticket-redirect`,
            'app-detail': appStoreUrl +'/appstore/app-detail?app_code='+app_code +'&return=no_return&post_message=online&trackingId=phantompdf_online',
            'my-cards': appStoreUrl +'/appstore/my-cards' + '?return=no_return&post_message=online&trackingId=phantompdf_online',
            'my-invoices':appStoreUrl +'/appstore/my-invoices'  + '?return=no_return&post_message=online&trackingId=phantompdf_online'
        }
 */
//http://cmsen.foxitsoftware.cn/shopping/subscription-checkout.html?identify=FPMS&license=yearly&language=en-us
export const APP_TARGETS = {
  'app-detail'  : '/shopping/subscription-checkout.html',   //
  'my-order'    : '/account/subscription.html',
  'app-list'    : '/shopping/',
  'new-app-list': '/shopping/subscription-checkout.html',
  'my-cards'    : '/account/credit-card.html',
  'my-invoices' : '/account/orders.html',
}

export const APP_SHOPPING_URLS = {
  us:'https://www.foxit.com/shopping.html',
  demo4: 'http://cmsen.foxitsoftware.cn/shopping.html'
}
export const APP_SHOPPING_DOMAIN_URLS = {
  us:'https://www.foxit.com',
  demo4: 'http://cmsen.foxitsoftware.cn'
}

export const PLUGIN_URLS = {
  pageEditor: '/plugin/plugins/pageeditor/manifest.json'
  // pageEditor: process.env.NODE_ENV === 'development' ? 'https://pageeditor-azk8s.foxitcloud.com/manifest.json' : '/plugin/plugins/pageeditor/manifest.json',
}
